module.exports = __webpack_public_path__ + "static/img/img_fuwu_yunpingtai.8441b3a3.png";